import React from 'react';
import { Configure, InstantSearch, connectHits } from 'react-instantsearch-dom';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import qs from 'query-string';
import ReactGA from 'react-ga';
import './App.css';
import withURLSync from './URLSync';
import ConnectedCurrentRefinements from './components/Algolia/ConnectedCurrentRefinements';
import ConnectedPagination from './components/Algolia/ConnectedPagination';
import CaptureAdvId from './components/CaptureAdvId';
import CodeDialog from './components/CodeDialog';
import CreativeCard from './components/CreativeCard';
import SideFilters from './components/SideFilters';
import TitleBar from './components/TitleBar';

export const getParameter = name => {
  const args = qs.parse(window.location.search);
  return (args || {})[name] || null;
};

ReactGA.initialize('UA-25669471-12');
ReactGA.set({
  dimension1: getParameter('adv_id') || window.localStorage.getItem('adv_id'),
});

ReactGA.pageview(window.location.pathname + window.location.search);
ReactGA.event({
  category: 'Visit',
  action: 'Advertiser',
  label: getParameter('adv_id') || window.localStorage.getItem('adv_id'),
});

const App = props => (
  <MuiThemeProvider>
    <MaterialUiExample {...props} />
  </MuiThemeProvider>
);

const isMobile = window.innerWidth < 450;

const MaterialUiExample = props => (
  <InstantSearch
    appId="VJOC5YGK89"
    apiKey="c5546bdfb4d3f31daf49ed3bb1463561"
    indexName="creatives"
    searchState={props.searchState}
    createURL={props.createURL}
    onSearchStateChange={props.onSearchStateChange}
  >
    <Configure
      hitsPerPage={8}
      filters={
        '(ProgramType:Legacy OR ProgramType:Internal) AND NOT OverlayActive:false'
      }
    />
    <CaptureAdvId />
    <Content />
  </InstantSearch>
);

class Content extends React.Component {
  constructor() {
    super();
    this.state = {
      drawer: !isMobile,
      codeDialog: null,
      codeDialogOpen: false,
      currentCreative: null,
    };
  }
  onDrawerClick = () => {
    this.setState({ drawer: !this.state.drawer });
  };

  onCodeDialogClose = () => {
    this.setState({ codeDialogOpen: false });
  };

  onGetCode = hit => event => {
    this.setState({ codeDialogOpen: true, currentCreative: hit });
  };

  render() {
    const defaultMarginLeft = isMobile ? window.innerWidth : 300;
    const marginLeft = this.state.drawer ? defaultMarginLeft : 0;
    const { codeDialogOpen, currentCreative } = this.state;
    return (
      <div>
        <TitleBar onSideClick={this.onDrawerClick} />

        <div className="main">
          <SideFilters drawerState={this.state.drawer} />

          <div
            className="Content__hits"
            style={{
              marginLeft,
              display: 'flex',
              flexDirection: 'column',
              marginTop: 65,
            }}
          >
            <div style={{ paddingLeft: 26, paddingBottom: 8 }}>
              <ConnectedCurrentRefinements clearsQuery />
            </div>
            <CodeDialog
              open={codeDialogOpen}
              creative={currentCreative}
              onClose={this.onCodeDialogClose}
            />

            <ConnectedHits onGetCode={this.onGetCode} />
          </div>
        </div>
      </div>
    );
  }
}

function CustomHits({ hits, marginLeft, hasMore, refine, onGetCode }) {
  const containerCardStyle = {
    marginLeft,
    paddingLeft: isMobile ? 0 : 24,
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div>
      <main id="hits" style={containerCardStyle}>
        {hits.map(hit => (
          <CreativeCard hit={hit} onGetCode={onGetCode} key={hit.ObjectID} />
        ))}
      </main>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <ConnectedPagination />
      </div>
    </div>
  );
}

const ConnectedHits = connectHits(CustomHits);

export default withURLSync(App);



// WEBPACK FOOTER //
// ./src/App.js